// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2c0rZ","rootSmall":"AddTileButton_rootSmall__3uz_o"};